'use client';

import { createContext, useContext, useEffect, useState, type PropsWithChildren } from 'react';

const ADMIN_VISIBILITY_KEY = 'makeoff_admin_buttons_visible';

interface AdminVisibilityContextType {
  isVisible: boolean;
  toggle: () => void;
}

const AdminVisibilityContext = createContext<AdminVisibilityContextType | undefined>(undefined);

export function AdminVisibilityProvider({ children }: PropsWithChildren) {
  const [isVisible, setIsVisible] = useState(false);

  // Load from sessionStorage on mount
  useEffect(() => {
    const stored = sessionStorage.getItem(ADMIN_VISIBILITY_KEY);
    setIsVisible(stored === 'true');
  }, []);

  const toggle = () => {
    setIsVisible((prev) => {
      const newValue = !prev;
      sessionStorage.setItem(ADMIN_VISIBILITY_KEY, String(newValue));
      return newValue;
    });
  };

  return (
    <AdminVisibilityContext.Provider value={{ isVisible, toggle }}>
      {children}
    </AdminVisibilityContext.Provider>
  );
}

export function useAdminVisibility() {
  const context = useContext(AdminVisibilityContext);
  if (context === undefined) {
    throw new Error('useAdminVisibility must be used within AdminVisibilityProvider');
  }
  return context;
}
